<template>
  <component
    :is="tag"
    v-bind="$attrs"
    class="a-button"
    v-ripple
    @click="$emit('click', $event)"
  >
    <slot/>
  </component>
</template>

<style lang="scss">
.v-application .a-button {
  display: inline-block;
  text-decoration: inherit;
  color: inherit;

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: default;
  }
}
</style>

<script>
export default {
  name: 'AButton',
  inheritAttrs: false,
  computed: {
    tag () {
      if ('to' in this.$attrs) {
        return 'router-link'
      } else if ('href' in this.$attrs) {
        return 'a'
      }
      return 'button'
    }
  }
}
</script>
